module.exports = __webpack_public_path__ + "img/player-previous.606dd721.svg";